export enum GameType {
  JEOPARDY = "JEOPARDY",
  QUIZ = "QUIZ",
}
